import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'previsualizacion',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input('preguntasAdicionales') preguntasAdicionales: backInter.getAdicionales;
  @Input() actualizaAdicionales: Observable<any>;

  cargando = true;

  private eventsSubscription: any

  folders: any[] = [
    { name: "Ejemplo1", updated:2018},
    { name: "Ejemplo2", updated:2019},
    { name: "Ejemplo3", updated:2020}
  ];

  idiomaDefault: backInter.getIdiomaInd;
  textosPreguntasFiltrados: any[] = [];
  totalTextosTraduccion = 0;
  numeroTextosTraduccion: number[] = [];

  idiomasFiltrados: any[] = [];

  primeraSeleccion = false;

  //tipos de pregunta
  idAbierta = 2;
  idSingle = 1;
  idMulti = 6;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.eventsSubscription = this.actualizaAdicionales.subscribe( (datos) => {
      console.log("actualizar");
      this.reiniciaVariables();
      this.preguntasAdicionales = datos;
      this.obtieneIdiomas();
      this.limpiaListadoIdiomas();
      // this.colocaPreview();
      // this.obtieneIdiomas();
    })
    setTimeout( () => {
      this.cargando = false;
      this.obtieneIdiomas();
      this.limpiaListadoIdiomas();
      // this.colocaPreview();

      console.log(this.idiomas);
    },2000);
  }

  reiniciaVariables(){
    this.preguntasAdicionales = null;
    this.idiomaDefault = null;
    this.textosPreguntasFiltrados = [];
    this.totalTextosTraduccion = 0;
    this.numeroTextosTraduccion = [];
    this.idiomasFiltrados = [];
  }

  limpiaListadoIdiomas(){
    if(this.idiomas.idiomasMostrar.length > 0){

      this.idiomas.idiomasMostrar.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma != "3"){
          this.idiomasFiltrados.push(idioma);
        }

      });
    }
  }

  obtieneIdiomas(){
    if(this.idiomas.idiomasMostrar.length > 0){

      this.idiomas.idiomasMostrar.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma == "1"){
          this.idiomaDefault = idioma;
        }

      });
    }
  }

  colocaPreview(idIdioma:string){
    // console.log(this.preguntasAdicionales);
    // console.log(this.idiomas);
    this.preguntasAdicionales.adicionalesMostrar.forEach( (adicional) => {

      adicional.adicional.forEach( (textos) => {

        // if(textos.idiomaAdicionales == this.idiomaDefault._id){
        if(textos.idiomaAdicionales == idIdioma){

          let objetoTextoAdicional = {};
          let numeroTextos = 0;
          if(textos.tipoPreguntaAdicionales == this.idAbierta){
            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              idAdicional : adicional._id,
              orden: adicional.orden
            };
            numeroTextos++;
            this.totalTextosTraduccion++;
          }
          else if(textos.tipoPreguntaAdicionales == this.idSingle || textos.tipoPreguntaAdicionales == this.idMulti){
            let textosOpciones: any[] = [];
            textos.opciones.forEach( (txtOpcion) => {
              textosOpciones.push({textoOpcion: txtOpcion.textoOpcion, ordenOpcion: txtOpcion.ordenOpcion});
              numeroTextos++;
              this.totalTextosTraduccion++;
            });
            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              opcionesResp : textosOpciones,
              idAdicional : adicional._id,
              orden: adicional.orden
            };
            numeroTextos++;
            this.totalTextosTraduccion++;
          }

          this.textosPreguntasFiltrados.push(objetoTextoAdicional);
          this.numeroTextosTraduccion.push(numeroTextos);

        }

      });

    });

    // console.log(this.textosPreguntasFiltrados);
    // console.log(this.numeroTextosTraduccion);
  }

  selIdiomaPreview(idLang:any){
    // console.log("idioma seleccionado: ");
    // console.log(idLang);
    this.primeraSeleccion = true;
    this.textosPreguntasFiltrados = [];
    this.numeroTextosTraduccion = [];
    this.totalTextosTraduccion = 0;
    this.colocaPreview(idLang._id);
  }

}
